export interface Dish {
  id: string;
  name: string;
  description: string;
  calories: number;
  category: string;
  image: string;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
}

export const categories: Category[] = [
  { id: "ana-yemek", name: "Ana Yemek", icon: "ri-restaurant-line" },
  { id: "eslikci", name: "Eşlikçi", icon: "ri-bowl-line" },
  { id: "yan-urun", name: "Yan Ürün", icon: "ri-cup-line" },
  { id: "corba", name: "Çorba", icon: "ri-rainbow-line" },
  { id: "salata", name: "Salata", icon: "ri-leaf-line" },
  { id: "tatli", name: "Tatlı", icon: "ri-cake-3-line" },
];

export const dishes: Dish[] = [
  {
    id: "etli-kuru-fasulye",
    name: "Etli Kuru Fasulye",
    description: "Yavaş pişirilmiş kuru fasulye, dana eti ve domates sosu.",
    calories: 380,
    category: "ana-yemek",
    image: "https://readdy.ai/api/search-image?query=Traditional%20Turkish%20white%20bean%20stew%20with%20tender%20beef%20chunks%20in%20rich%20tomato%20sauce%20served%20in%20rustic%20ceramic%20bowl%2C%20steam%20rising%2C%20warm%20home%20kitchen%20atmosphere%2C%20soft%20natural%20window%20light%2C%20garnished%20with%20fresh%20parsley%2C%20editorial%20food%20photography%20close%20up%2C%20simple%20warm%20cream%20background%2C%20appetizing%20and%20authentic&width=800&height=600&seq=dish-kuru-fasulye&orientation=landscape",
  },
  {
    id: "tavuk-sote",
    name: "Tavuk Sote",
    description: "Biber, domates ve baharatla sotelenmiş sulu tavuk.",
    calories: 320,
    category: "ana-yemek",
    image: "https://readdy.ai/api/search-image?query=Turkish%20chicken%20saute%20with%20green%20peppers%20tomatoes%20and%20onions%20in%20glossy%20tomato%20sauce%2C%20served%20in%20rustic%20copper%20pan%2C%20steam%20rising%2C%20warm%20natural%20light%2C%20home%20kitchen%20vibe%2C%20garnished%20with%20parsley%2C%20editorial%20food%20photography%2C%20simple%20warm%20cream%20background%2C%20appetizing%20detail&width=800&height=600&seq=dish-tavuk-sote&orientation=landscape",
  },
  {
    id: "kofta",
    name: "Izgara Köfte",
    description: "El yapımı, közde pişirilmiş baharatlı köfte.",
    calories: 410,
    category: "ana-yemek",
    image: "https://readdy.ai/api/search-image?query=Grilled%20Turkish%20meatballs%20kofte%20with%20charred%20edges%20on%20cast%20iron%20skillet%2C%20garnished%20with%20grilled%20tomato%20and%20parsley%2C%20steam%20rising%2C%20warm%20natural%20light%2C%20home%20kitchen%20atmosphere%2C%20editorial%20food%20photography%20close%20up%2C%20simple%20warm%20cream%20background%2C%20juicy%20appetizing&width=800&height=600&seq=dish-kofte&orientation=landscape",
  },
  {
    id: "karniyarik",
    name: "Karnıyarık",
    description: "Kıymalı iç harçla doldurulmuş közlenmiş patlıcan.",
    calories: 360,
    category: "ana-yemek",
    image: "https://readdy.ai/api/search-image?query=Turkish%20karniyarik%20stuffed%20eggplant%20with%20seasoned%20ground%20beef%20topping%20in%20tomato%20sauce%2C%20roasted%20eggplant%20glossy%2C%20served%20on%20rustic%20plate%2C%20steam%20rising%2C%20warm%20home%20kitchen%20light%2C%20editorial%20food%20photography%2C%20simple%20warm%20cream%20background%2C%20authentic%20Turkish%20comfort%20food&width=800&height=600&seq=dish-karniyarik&orientation=landscape",
  },
  {
    id: "pirinc-pilavi",
    name: "Tereyağlı Pirinç Pilavı",
    description: "Tane tane, tereyağlı klasik pirinç pilavı.",
    calories: 280,
    category: "eslikci",
    image: "https://readdy.ai/api/search-image?query=Fluffy%20Turkish%20butter%20rice%20pilaf%20with%20separate%20grains%20steaming%20in%20a%20copper%20pot%2C%20mound%20of%20white%20rice%20on%20plate%2C%20warm%20natural%20light%2C%20home%20kitchen%20atmosphere%2C%20editorial%20food%20photography%20close%20up%2C%20simple%20warm%20cream%20background%2C%20appetizing%20buttery%20sheen&width=800&height=600&seq=dish-pirinc&orientation=landscape",
  },
  {
    id: "bulgur-pilavi",
    name: "Domatesli Bulgur Pilavı",
    description: "Domates ve salçayla kavrulmuş iri taneli bulgur.",
    calories: 300,
    category: "eslikci",
    image: "https://readdy.ai/api/search-image?query=Turkish%20tomato%20bulgur%20pilaf%20with%20coarse%20bulgur%20grains%20and%20red%20pepper%20flakes%2C%20served%20on%20rustic%20plate%2C%20steam%20rising%2C%20warm%20natural%20light%2C%20home%20kitchen%20vibe%2C%20editorial%20food%20photography%2C%20simple%20warm%20cream%20background%2C%20authentic%20appetizing&width=800&height=600&seq=dish-bulgur&orientation=landscape",
  },
  {
    id: "makarna",
    name: "Fırın Makarna",
    description: "Üzeri kızarmış kaşarlı fırın makarna.",
    calories: 420,
    category: "eslikci",
    image: "https://readdy.ai/api/search-image?query=Baked%20Turkish%20pasta%20with%20melted%20golden%20cheese%20crust%20in%20ceramic%20baking%20dish%2C%20steam%20rising%2C%20warm%20natural%20light%2C%20home%20kitchen%20atmosphere%2C%20editorial%20food%20photography%20close%20up%2C%20simple%20warm%20cream%20background%2C%20cheesy%20appetizing&width=800&height=600&seq=dish-makarna&orientation=landscape",
  },
  {
    id: "cacik",
    name: "Cacık",
    description: "Salatalık, sarımsak ve nane ile ferah cacık.",
    calories: 110,
    category: "yan-urun",
    image: "https://readdy.ai/api/search-image?query=Turkish%20cacik%20yogurt%20cucumber%20dip%20with%20fresh%20dill%20and%20mint%20in%20ceramic%20bowl%2C%20cool%20refreshing%2C%20warm%20natural%20light%2C%20home%20kitchen%20vibe%2C%20editorial%20food%20photography%20close%20up%2C%20simple%20warm%20cream%20background%2C%20fresh%20appetizing&width=800&height=600&seq=dish-cacik&orientation=landscape",
  },
  {
    id: "yogurt",
    name: "Ev Yoğurdu",
    description: "Koyu kıvamlı, günlük taze ev yoğurdu.",
    calories: 120,
    category: "yan-urun",
    image: "https://readdy.ai/api/search-image?query=Creamy%20thick%20homemade%20Turkish%20yogurt%20in%20rustic%20ceramic%20bowl%20with%20wooden%20spoon%2C%20smooth%20texture%2C%20warm%20natural%20light%2C%20home%20kitchen%20atmosphere%2C%20editorial%20food%20photography%2C%20simple%20warm%20cream%20background%2C%20fresh%20wholesome&width=800&height=600&seq=dish-yogurt&orientation=landscape",
  },
  {
    id: "tursu",
    name: "Ev Turşusu",
    description: "Mevsim sebzelerinden ev yapımı karışık turşu.",
    calories: 60,
    category: "yan-urun",
    image: "https://readdy.ai/api/search-image?query=Turkish%20homemade%20mixed%20pickles%20with%20cucumber%20carrot%20and%20cabbage%20in%20glass%20jar%2C%20colorful%20brine%2C%20warm%20natural%20light%2C%20home%20kitchen%20vibe%2C%20editorial%20food%20photography%20close%20up%2C%20simple%20warm%20cream%20background%2C%20fresh%20crunchy&width=800&height=600&seq=dish-tursu&orientation=landscape",
  },
  {
    id: "mercimek-corbasi",
    name: "Mercimek Çorbası",
    description: "Tereyağlı ve limonlu klasik mercimek çorbası.",
    calories: 180,
    category: "corba",
    image: "https://readdy.ai/api/search-image?query=Turkish%20red%20lentil%20soup%20with%20butter%20drizzle%20and%20dried%20mint%20in%20ceramic%20bowl%2C%20smooth%20orange%20texture%2C%20lemon%20wedge%20beside%2C%20steam%20rising%2C%20warm%20natural%20light%2C%20home%20kitchen%20vibe%2C%20editorial%20food%20photography%2C%20simple%20warm%20cream%20background&width=800&height=600&seq=dish-mercimek&orientation=landscape",
  },
  {
    id: "ezogelin",
    name: "Ezogelin Çorbası",
    description: "Kırmızı mercimek ve bulgurlu geleneksel çorba.",
    calories: 190,
    category: "corba",
    image: "https://readdy.ai/api/search-image?query=Turkish%20ezogelin%20soup%20with%20red%20lentils%20bulgur%20and%20tomato%20paste%20in%20ceramic%20bowl%2C%20garnished%20with%20mint%2C%20steam%20rising%2C%20warm%20natural%20light%2C%20home%20kitchen%20atmosphere%2C%20editorial%20food%20photography%2C%20simple%20warm%20cream%20background%2C%20hearty&width=800&height=600&seq=dish-ezogelin&orientation=landscape",
  },
  {
    id: "yayla",
    name: "Yayla Çorbası",
    description: "Pirinç ve yoğurtlu, naneli ferah yayla çorbası.",
    calories: 170,
    category: "corba",
    image: "https://readdy.ai/api/search-image?query=Turkish%20yayla%20yogurt%20soup%20with%20rice%20and%20dried%20mint%20in%20ceramic%20bowl%2C%20creamy%20white%20texture%2C%20steam%20rising%2C%20warm%20natural%20light%2C%20home%20kitchen%20vibe%2C%20editorial%20food%20photography%20close%20up%2C%20simple%20warm%20cream%20background%2C%20comforting&width=800&height=600&seq=dish-yayla&orientation=landscape",
  },
  {
    id: "mevsim-salatasi",
    name: "Mevsim Salatası",
    description: "Mevsim yeşillikleri, zeytinyağı ve limon.",
    calories: 90,
    category: "salata",
    image: "https://readdy.ai/api/search-image?query=Fresh%20seasonal%20Turkish%20salad%20with%20mixed%20greens%20cherry%20tomatoes%20cucumber%20and%20olive%20oil%20drizzle%20in%20ceramic%20bowl%2C%20vibrant%20colors%2C%20warm%20natural%20light%2C%20home%20kitchen%20vibe%2C%20editorial%20food%20photography%2C%20simple%20warm%20cream%20background%2C%20fresh%20crisp&width=800&height=600&seq=dish-mevsim-salata&orientation=landscape",
  },
  {
    id: "coban-salata",
    name: "Çoban Salata",
    description: "Domates, salatalık, biber ve soğanla klasik çoban salata.",
    calories: 80,
    category: "salata",
    image: "https://readdy.ai/api/search-image?query=Turkish%20coban%20salata%20chopped%20tomato%20cucumber%20onion%20green%20pepper%20with%20olive%20oil%20in%20ceramic%20bowl%2C%20colorful%20fresh%20vegetables%2C%20warm%20natural%20light%2C%20home%20kitchen%20vibe%2C%20editorial%20food%20photography%2C%20simple%20warm%20cream%20background&width=800&height=600&seq=dish-coban&orientation=landscape",
  },
  {
    id: "sutlac",
    name: "Fırın Sütlaç",
    description: "Üzeri kızarmış, kaymaklı fırın sütlaç.",
    calories: 240,
    category: "tatli",
    image: "https://readdy.ai/api/search-image?query=Turkish%20baked%20rice%20pudding%20firin%20sutlac%20with%20caramelized%20golden%20top%20in%20clay%20pot%2C%20creamy%20texture%2C%20warm%20natural%20light%2C%20home%20kitchen%20atmosphere%2C%20editorial%20food%20photography%20close%20up%2C%20simple%20warm%20cream%20background%2C%20comforting%20dessert&width=800&height=600&seq=dish-sutlac&orientation=landscape",
  },
  {
    id: "irmik-helvasi",
    name: "İrmik Helvası",
    description: "Tereyağı ve çam fıstıklı geleneksel irmik helvası.",
    calories: 280,
    category: "tatli",
    image: "https://readdy.ai/api/search-image?query=Turkish%20semolina%20halva%20with%20pine%20nuts%20on%20top%20served%20in%20rustic%20bowl%2C%20golden%20crumbly%20texture%2C%20warm%20natural%20light%2C%20home%20kitchen%20vibe%2C%20editorial%20food%20photography%2C%20simple%20warm%20cream%20background%2C%20traditional%20dessert&width=800&height=600&seq=dish-irmik&orientation=landscape",
  },
];

export const reviews = [
  {
    quote: "Yemekler tam anne eli gibi. Sıcak geldi, porsiyonu gerçekten doyurucu.",
    source: "Google Yorumları",
  },
  {
    quote: "Her gün kendi menümü seçebilmek çok rahat. Lezzeti de fiyatına göre çok iyi.",
    source: "Google Yorumları",
  },
  {
    quote: "Teslimat tam söz verilen saatte geldi. Mercimek çorbası enfesti.",
    source: "Google Yorumları",
  },
];

export const faqs = [
  {
    q: "Her gün aynı yemek mi geliyor?",
    a: "Hayır. Menüdeki alternatifler arasından her gün kendi öğününü seçersin.",
  },
  {
    q: "Menümü kendim seçebilir miyim?",
    a: "Evet. Ana yemek, çorba, salata, tatlı gibi kategorilerden seçim yaparak kendi menünü oluşturursun.",
  },
  {
    q: "Sipariş ne zaman kilitleniyor?",
    a: "Sipariş kilitlenme saatleri teslimat takvimine göre belirlenir. Detaylar sipariş adımında gösterilir.",
  },
  {
    q: "Yemek sıcak mı geliyor?",
    a: "Yemekler günlük hazırlanır ve planlanan teslimat aralığında sıcak olarak teslim edilir.",
  },
  {
    q: "Tek kişi sipariş verebilir mi?",
    a: "Evet, bireysel sipariş verebilirsin.",
  },
  {
    q: "İlk sipariş modeli nasıl çalışıyor?",
    a: "İlk sipariş modeli iki öğünlük başlangıç planıyla çalışır. Detaylar satın alma öncesinde açıkça gösterilir.",
  },
  {
    q: "Bölgeme teslimat var mı?",
    a: "Bölge kontrolü alanından ilçe veya mahallenizi yazarak teslimat durumunu öğrenebilirsiniz.",
  },
  {
    q: "Kurumsal sipariş verebilir miyim?",
    a: "Evet. Kurumsal yemek bölümünden teklif formu doldurabilirsiniz.",
  },
  {
    q: "Üye olmadan menüyü görebilir miyim?",
    a: "Evet. Menüyü keşfedebilir ve seçim yapabilirsiniz; üyelik menüyü kaydetme adımında devreye girer.",
  },
];

export const certificates = [
  { id: "isletme", name: "İşletme Kayıt Bilgisi", icon: "ri-building-2-line" },
  { id: "iso22000", name: "ISO 22000:2018", icon: "ri-shield-check-line" },
  { id: "iso9001", name: "ISO 9001:2015", icon: "ri-award-line" },
  { id: "iso14001", name: "ISO 14001:2015", icon: "ri-leaf-line" },
  { id: "iso45001", name: "ISO 45001:2018", icon: "ri-empathize-line" },
  { id: "iso10002", name: "ISO 10002:2018", icon: "ri-service-line" },
  { id: "etbis", name: "ETBİS Kaydı", icon: "ri-verified-badge-line" },
];